"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInput = void 0;
const react_1 = __importStar(require("react"));
const Colors_1 = require("../../../Colors");
const common_1 = require("../../../common");
exports.SearchInput = (0, react_1.forwardRef)(({ className = '', defaultValue, isIconHide, setSearchOption, ...props }, ref) => {
    const inputRef = (0, react_1.useRef)(null);
    const [isFocused, setIsFocused] = (0, react_1.useState)(false);
    (0, react_1.useImperativeHandle)(ref, () => ({
        focus: () => inputRef.current?.focus(),
        getValue: () => inputRef.current?.value || '',
        setValue: (newValue) => {
            if (inputRef.current) {
                inputRef.current.value = newValue;
            }
        },
    }));
    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => setIsFocused(false);
    const getSize = () => {
        if (className.includes('sm'))
            return 20;
        if (className.includes('lg'))
            return 28;
        return 24;
    };
    const onSubmit = () => {
        if (inputRef.current) {
            setSearchOption(inputRef.current.value);
        }
    };
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            onSubmit();
        }
    };
    react_1.default.useEffect(() => {
        if (inputRef.current) {
            inputRef.current.value = defaultValue || '';
        }
    }, [defaultValue]);
    return (react_1.default.createElement("div", { className: `flex row search-bar search-admin-bar ${className} ${isFocused ? 'focus' : ''}` },
        react_1.default.createElement("input", { ref: inputRef, defaultValue: defaultValue, onFocus: handleFocus, onBlur: handleBlur, onKeyDown: handleKeyDown, placeholder: "\uAC80\uC0C9\uC5B4\uB97C \uC785\uB825\uD558\uC138\uC694", ...props }),
        !isIconHide && (react_1.default.createElement("div", { className: "flex row icon", onClick: onSubmit },
            react_1.default.createElement(common_1.Icon, { icon: "search", size: getSize(), fill: Colors_1.Colors.tur })))));
});
